export function CellQuantity({ info }: any) {
    return <p style={{ textAlign: 'center' }}>{info.row.original.quantity}</p>;
}
